<template>
  <div class="s-box">
    <div class="box-msk"></div>
     <!-- mask: `linear-gradient(${degList[direction]}, #000 70%, transparent)`, -->
    <div
      :ref="'scrollBox' + refIndex"
      :class="`infinite-scroll-component-box-${direction}`"
      :style="{
        '--speed-': `${speed}s`,
        
      }"
      @click="onClick"
    >
      <div class="scroll-content" :ref="'scrollContent' + refIndex">
        <template v-if="Array.isArray(dataList)">
          <div
            v-for="(item, index) in dataList"
            :key="'arrayFirst' + index"
            class="loop-item"
          >
            <slot :item="item" :index="index"></slot>
          </div>
          <template v-if="loop">
            <div
              v-for="(item, index) in dataList"
              class="loop-item"
              :key="'arrayCopy' + index"
            >
              <slot :item="item" :index="index"></slot>
            </div>
          </template>
        </template>
        <template v-else>
          <slot></slot>
          <slot v-if="loop"></slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeamlessScroll',
  props: {
    content: {
      type: [String, Array],
      default: () => []
    },
    length: { // 列表的长度
      type: Number,
      default: 0
    },
    direction: {
      type: String,
      default: 'left',
      validate: (value) => ['left', 'top', 'right', 'bottom'].findIndex(value) !== -1,
    },
    mask: {
      type: Boolean,
      default: false,
    },
    // 速率倍速，越大越快，默认值20
    speedRate: {
      type: Number,
      default: 20,
    },
    refIndex: { // 当前的索引
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      degList: {
        left: '90deg',
        top: '180deg',
        right: '270deg',
        bottom: '0deg',
      },
      speed: 0, // 滚动速度
      loop: false, // 是否循环
      scrollBox: null, // 滚动盒子
      dataList: [], // 数据列表
    }
  },
  created() {
    this.dataList = this.content
    if(this.dataList.length > this.length) {
      setTimeout(() => {
        this.init()
      }, 1000)
    }
  },
  computed: {
    
  },
  mounted() {
    
  },
  beforeUnmount() {
    
  },
  methods: {
    onClick() {
      return
    },
    init() {
      if (this.direction === 'left' || this.direction === 'right') {
        // 可视区域的宽度
        const boxWidth = this.$refs['scrollBox' + this.refIndex].offsetWidth
        // 滚动内容的宽度
        const itemWidth = this.$refs['scrollBox' + this.refIndex].getElementsByClassName('scroll-content')[0].offsetWidth
        if (itemWidth >= boxWidth) {
          this.loop = true
          this.speed = itemWidth / this.speedRate
        } else {
          this.speed = 0
          this.$refs['scrollBox' + this.refIndex].getElementsByClassName(
            'scroll-content'
          )[0].style.transform = 'translateX(0)'
          this.loop = false
        }
      } else {
        const boxHeight = this.$refs['scrollBox' + this.refIndex].offsetHeight
        const itemHeight = this.$refs['scrollBox' + this.refIndex].getElementsByClassName('scroll-content')[0].offsetHeight
        if (itemHeight >= boxHeight) {
          this.loop = true
          this.speed = itemHeight / this.speedRate
        } else {
          this.speed = 0
          this.$refs['scrollBox' + this.refIndex].getElementsByClassName(
            'scroll-content'
          )[0].style.transform = 'translateY(0)'
          this.loop = false
        }
      }
    }
  },
  watch: {
    content(newVal) {
      this.dataList = newVal
      this.loop = false
      this.init()
    }
  }
}
</script>

<style scoped lang="scss">
.s-box {
  width: 100%;
  height: 100%;
  position: relative;
  .box-msk {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background: rgba(0, 0, 0, 0);
    opacity: 0;
  }
}
.infinite-scroll-component-box-left,
.infinite-scroll-component-box-right {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  .scroll-content {
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      animation-play-state: paused;
    }
  }
}
.infinite-scroll-component-box-top,
.infinite-scroll-component-box-bottom {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  .scroll-content {
    width: 100%;
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      animation-play-state: paused;
    }

    .loop-item {
      width: 100%;
    }
  }
}
.infinite-scroll-component-box-left .scroll-content {
  flex-direction: row;
  animation: var(--speed-) move-left linear infinite;

  @keyframes move-left {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
}

.infinite-scroll-component-box-right .scroll-content {
  flex-direction: row-reverse;
  animation: var(--speed-) move-right linear infinite;

  @keyframes move-right {
    0% {
      transform: translateX(-50%);
    }
    100% {
      transform: translateX(0);
    }
  }
}

.infinite-scroll-component-box-top .scroll-content {
  flex-direction: column;
  animation: var(--speed-) move-top linear infinite;

  @keyframes move-top {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-50%);
    }
  }
}

.infinite-scroll-component-box-bottom .scroll-content {
  flex-direction: column-reverse;
  animation: var(--speed-) move-bottom linear infinite;

  @keyframes move-bottom {
    0% {
      transform: translateY(-50%);
    }
    100% {
      transform: translateY(0);
    }
  }
}
.scroll-content ::-webkit-scrollbar {
  display: none;
}
</style>